import ErrorMessage from '../../components/info-messages/ErrorMessage';
import { ContextInfoMessage } from '@sb1/ffe-context-message-react';
import Input2 from '../../components/input/input-2/Input2';
import RoundedButtonPrimary from '../../components/button/rounded-button-primary/RoundedButtonPrimary';
import { saveRegistration } from './giveaway-actions';
import isEmail from 'validator/lib/isEmail';
import { useEffect, useState } from 'react';
import { hasWindow } from '../../utils';
import { useProject } from '../project-hooks/useProject';
import { useSelector } from 'react-redux';
import styles from './giveaway-form.module.less';
import { useUser } from '../../user/useUser';
import { getNameFormatted } from '../../user/user-model';
import RoundedButtonSecondary from '../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import { ContextMessage } from '@sb1/ffe-messages-react';

export const GiveawayForm = ({ close, setSuccess, error, setError, loading, setLoading, skip, intro }) => {
    const project = useProject();
    const user = useUser();
    const transaction = useSelector((state) => state.transactions.transactionForGiverInfo);
    const [email, setEmail] = useState(transaction?.email || user?.email);
    const [name, setName] = useState(transaction?.from_user_meta_data?.name || getNameFormatted(user));
    const [fpAgent, setFpAgent] = useState(null);

    const disclaimer = project?.profile?.giveaway?.disclaimer;
    const { recaptchaSiteKey, baseURL } = useSelector((state) => ({
        recaptchaSiteKey: state.recaptchaV3SiteKey,
        baseURL: state.baseURL,
    }));
    const [blocked] = useState(false);

    useEffect(() => {
        if (hasWindow()) {
            const Fingerprint = require('@fingerprintjs/fingerprintjs-pro');
            Fingerprint.load({
                apiKey: 'Y9CZ3FkA4IA06LHmMQka',
                region: 'eu',
                endpoint: 'https://fp.spleis.no',
                scriptUrlPattern: 'https://fp.spleis.no/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
            }).then((clientAgent) => {
                setFpAgent(clientAgent);
            });
        }
    }, []);

    const validate = () => {
        let validationMessage = { ...error.global };
        if (!name || name.length === 0) {
            validationMessage = { ...validationMessage, name: 'Navn er påkrevet' };
        }

        if (!email || !isEmail(email)) {
            validationMessage = { ...validationMessage, email: 'E-postadressen må være gyldig' };
        }

        if (validationMessage.name || validationMessage.email) {
            setError(validationMessage);
            return false;
        } else {
            setError({ ...error.global });
            return true;
        }
    };

    const save = async () => {
        if (!validate()) {
            return;
        }

        setLoading(true);
        if (window?.grecaptcha?.execute && recaptchaSiteKey) {
            try {
                //et lite hack fordi react-google-recaptcha-v3 ikke fungerer så godt, og jeg finner ikke noe bedre
                const captchaToken = await window.grecaptcha.execute(recaptchaSiteKey, {
                    action: 'giveaway_registration',
                });
                const result = await fpAgent.get();
                const fingerprint = result.visitorId;

                await saveRegistration({
                    baseURL,
                    email,
                    name,
                    projectId: project?.id,
                    fingerprint,
                    campaign: project.profile?.giveaway?.campaign,
                    captchaToken,
                });
                setLoading(false);
                setSuccess(true);
                setError({});
            } catch (e) {
                setLoading(false);
                return setError({
                    global: 'Det oppsto en feil når vi skulle registrere deg. Skru evt. av adblocker og prøv igjen.',
                });
            }
        } else {
            setLoading(false);
            return setError({
                global: 'Det oppsto en feil når vi skulle registrere deg. Skru evt. av adblocker og prøv igjen.',
            });
        }
    };

    return (
        <div>
            <p>{intro} For å bli med trenger vi navnet ditt og e-postadressen din.</p>
            {error?.global && <ErrorMessage>{error.global}</ErrorMessage>}
            <div className={styles.inputFields}>
                <Input2
                    fieldName="name"
                    title="Navn"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    error={error?.name}
                    readOnly={blocked}
                />
                <Input2
                    fieldName="email"
                    title="E-post"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={error?.email}
                    readOnly={blocked}
                />

                <p className={styles.terms}>
                    {disclaimer} Ditt navn og epost vil ikke brukes til markedsføring, og vil slettes etter at
                    innsamlingen er avsluttet.
                </p>
                <ContextMessage type="info" compact>
                    Dersom du har på adblocker eller sporingsbeskyttelse i nettleseren, må du skru dette av for å kunne
                    melde deg på trekningen. Chrome fungerer best.
                </ContextMessage>
                <div className={styles.buttons}>
                    {!skip && <RoundedButtonSecondary onClick={close}>Avbryt</RoundedButtonSecondary>}
                    {skip && <RoundedButtonSecondary onClick={skip}>Hopp over</RoundedButtonSecondary>}
                    <RoundedButtonPrimary onClick={save} disabled={loading || blocked}>
                        Bli med
                    </RoundedButtonPrimary>
                </div>
            </div>
        </div>
    );
};
